<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text"
        ><v-toolbar-title>THÊM CHƯƠNG TRÌNH ĐÀO TẠO</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="dialog = false">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <div class="mt-6">
            <v-autocomplete
              v-model="academicLevel"
              :items="academicLevels"
              outlined
              dense
              item-text="label"
              :rules="[$rules.required]"
              hide-details
              return-object
            >
              <template #label>
                <span>{{ 'Chọn Bộ môn' }}<strong class="red--text ml-1">* </strong></span>
              </template>
            </v-autocomplete>
          </div>
          <v-text-field
            outlined
            dense
            v-model="title"
            class="required mt-6"
            :rules="[$rules.required, titleRule]"
            label="Tên chương trình đào tạo"
            hide-details
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="dialog = false">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" :loading="loading" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
// import RadioAcademicLevel from '@/modules/academicLevel/RadioAcademicLevel.vue'
import { textHelpers } from '@/helpers/TextHelper.js'

export default {
  components: {},
  props: {
    state: Boolean,
  },
  data() {
    return {
      academicLevel: {},
      dialog: false,
      loading: false,
      title: '',
      titleRule: (v) => {
        const title = textHelpers.removeSpaces(v)
        const d = this.divisions.find((d) => d.title === title && d.academicLevel.id === this.academicLevel.id)
        return !d || 'Chương trình học này đã tồn tại'
      },
    }
  },
  computed: {
    ...mapState({
      divisions(state) {
        return state['division'].divisions
      },
      academicLevels(state) {
        return state['AcademicLevel'].academics
      },
    }),
  },
  methods: {
    ...mapActions('division', ['createDivision', 'fetchDivisionsWithAcademicLevel']),
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.loading = true
        await this.createDivision({
          title: this.title,
          academicLevel: this.academicLevel.id,
        })
        this.$alert.addSuccess()
        this.reset()
        this.fetchDivisionsWithAcademicLevel({})
        this.dialog = false
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.title = ''
      this.resetValidation()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
  watch: {
    state() {
      this.fetchDivisionsWithAcademicLevel({})
      this.dialog = true
    },
    academicLevels: {
      handler() {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      },
    },
  },
}
</script>
